var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServicessmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.8241 58.328L8.80811 40.536L24.2561 31.528L55.1921 49.392L39.8241 58.328Z",
    fill: "url(#paint0_linear_3_67360)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1921 23.584L24.2401 5.672L8.80811 14.592L39.7521 32.496L55.1921 23.584Z",
    fill: "url(#paint1_linear_3_67360)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7521 32.496L8.80811 14.512L8.83211 32.344L39.7761 50.328L39.7521 32.496Z",
    fill: "url(#paint2_linear_3_67360)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1922 23.584V41.424L39.7762 50.328L39.7522 32.496L55.1922 23.584Z",
    fill: "url(#paint3_linear_3_67360)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2962 45.056L31.4082 43.384V29.776L34.2962 31.448V45.056Z",
    fill: "url(#paint4_linear_3_67360)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9681 40.24L23.0801 38.568V24.96L25.9681 26.632V40.24Z",
    fill: "url(#paint5_linear_3_67360)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6401 35.424L14.7441 33.752V20.144L17.6401 21.816V35.424Z",
    fill: "url(#paint6_linear_3_67360)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_67360",
    x1: 16.5121,
    y1: 53.888,
    x2: 47.4721,
    y2: 36.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525252",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3_67360",
    x1: 8.80811,
    y1: 19.088,
    x2: 55.1921,
    y2: 19.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDCDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3_67360",
    x1: 8.80811,
    y1: 32.416,
    x2: 39.7761,
    y2: 32.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEBEBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3_67360",
    x1: 39.7522,
    y1: 36.952,
    x2: 55.1922,
    y2: 36.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEBEBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3_67360",
    x1: 31.4082,
    y1: 37.416,
    x2: 34.2962,
    y2: 37.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEBEBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3_67360",
    x1: 23.0801,
    y1: 32.6,
    x2: 25.9681,
    y2: 32.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEBEBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3_67360",
    x1: 14.7441,
    y1: 27.784,
    x2: 17.6401,
    y2: 27.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEBEBE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicessmall);
export default __webpack_public_path__ + "static/media/Services small.308fa45786c35e19e1957648e68a6793.svg";
export { ForwardRef as ReactComponent };